import { Component, ContentChild, Input, TemplateRef, ViewChild } from '@angular/core';

@Component({
  selector: 'app-tab',
  standalone: true,
  template: `<ng-template #content><ng-content></ng-content></ng-template>`,
})
export class TabComponent {
  @Input() label: string = '';
  @Input() disabled: boolean = false;
  @Input() routerLink: string | any[] | null = null;

  @ContentChild('tabLabel', { static: false }) labelTemplate: TemplateRef<any>;
  @ViewChild('content', { static: true }) contentTemplate: TemplateRef<any>;
}
